import type { PropsWithChildren } from "react";

export const Container = ({ children }: PropsWithChildren<unknown>) => (
  <div className="border-primary bg-primary flex flex-col gap-y-4 rounded-xl border p-6">
    {children}
  </div>
);
